//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StockControlledToolDepartments',
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
